import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import './InfoTable.scss';
/**
 * Info table is a component wrapper just for the styles!
 */
var InfoTable = function (props) {
    return React.createElement(Observer, { children: function () { return (React.createElement("table", { className: joinClassName('InfoTable', props.className), ref: props.tableRef }, props.children)); } });
};
export default InfoTable;
